import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { signOut } from '../../user/actions';
import { openModal } from '../../shared/actions';
import { isEmpty } from 'lodash';
import { TrackEventName } from '../../shared/constants/SegmentEvents';
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';

class MobileNav extends Component {
  onClick = (text) => {
    const { push, signOut } = this.props;
    switch (text) {
      case 'my_account':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_ACCOUNT_MY_ACCOUNT_CLICKED);
        push('/user_profile');
        break;
      case 'company_info':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_ACCOUNT_COMPANY_INFO_CLICKED);
        push('/company_information');
        break;
      case 'requirements':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_ACCOUNT_REQS_CLICKED);
        push('/requirements');
        break;
      case 'manage-alerts':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_ACCOUNT_ALERTS_MANAGER_CLICKED);
        push('/manage-alerts');
        break;
      case 'faqs':
        segmentEventTracker.trackEvent(TrackEventName.FAQS_CLICKED);
        window.open('https://firstcircle.zendesk.com', '_blank');
        break;
      case 'business_account':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_BUSINESS_ACCOUNT_CLICKED);
        window.open(this.supplierPaymentsLink, '_blank');
        break;
      case 'logout':
        segmentEventTracker.trackEvent(TrackEventName.NAVBAR_ACCOUNT_LOGOUT_CLICKED);
        signOut();
        break;
      default:
        return null;
    }
  }

  onOpenModal = () => {
    segmentEventTracker.trackEvent(TrackEventName.REFERRAL_BUTTON_CLICKED);
    this.props.openModal();
  }

  toggleZeWidget = menu_open => {
    if (!window.zE) return;
    if (menu_open) {
      window.zE('webWidget', 'hide');
    } else {
      window.zE('webWidget', 'show');
    }
  };

  get shouldDisplayLinkToSupplierPayments() {
    if (isEmpty(this.props.fc_lead) || !this.props.user.auth_token) { return false }
    const { id, supplier_payments_enabled_at } = this.props.fc_lead;
    const {
      businessAccountEnabled,
      businessAccountCreated,
      withBusinessAccountConsent
    } = this.props.businessAccount;

    return id && supplier_payments_enabled_at && businessAccountCreated && businessAccountEnabled && withBusinessAccountConsent;
  }

  get supplierPaymentsLink() {
    if (!this.shouldDisplayLinkToSupplierPayments) { return null }
    if (!this.props.user.active_business_trustpass) { return null }

    return `${process.env.REACT_APP_FC_CONNECT_BASE_URL}/leads/${this.props.user.active_business_trustpass.lead_id}/home`
  }

  renderSupplierPaymentsLink = () => {
    if (!this.shouldDisplayLinkToSupplierPayments) { return null }
    if (!this.props.user.active_business_trustpass) { return null }

    return (
      <li className="_displayFlex _alignItems-center" onClick={() => { this.onClick('business_account') }}>
        <i className='materialIcon'>schedule_send</i>
        <label className="_marginLeft--xxsmall copy -secondary"><strong>Business Account</strong></label>
      </li>
    );
  }

  render() {
    this.toggleZeWidget(this.props.referralModal);

    return (
      <div className="ds-card">
        <ul className="ds-list">
          <li className="_displayFlex _alignItems-center">
            <i className='materialIcon'>mood</i>
            <a data-testid="mobile-referral-modal" onClick={this.onOpenModal} className="ds-btn --small _outline -secondary"> Refer and Get ₱ 10,000!</a>
          </li>
          <li className="_displayFlex _alignItems-center" data-path="/user_profile" data-testid="mobile-my-account" onClick={() => { this.onClick('my_account') }}>
            <i className='materialIcon'>account_circle</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> User Details </strong></label>
          </li>
          <li className="_displayFlex _alignItems-center" data-path="/company_information" data-testid="mobile-company-info" onClick={() => { this.onClick('company_info') }}>
            <i className='materialIcon'>domain</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> Company Info </strong></label>
          </li>
          {this.renderSupplierPaymentsLink()}
          <li className="_displayFlex _alignItems-center" data-path="/requirements" data-testid="mobile-navbar-requirements" onClick={() => { this.onClick('requirements') }}>
            <i className='materialIcon'>playlist_add_check</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> Requirements </strong></label>
          </li>
          <li className="_displayFlex _alignItems-center" data-path="/manage-alerts" data-testid="alerts-manager-list-item" onClick={() => { this.onClick('manage-alerts') }}>
            <i className='materialIcon'>circle_notifications</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> Manage Alerts </strong></label>
          </li>
          <li className="_displayFlex _alignItems-center" data-path="https://firstcircle.zendesk.com" data-testid="mobile-faqs" onClick={() => { this.onClick('faqs') }}>
            <i className='materialIcon'>help</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> FAQs </strong></label>
          </li>
          <li className="_displayFlex _alignItems-center" data-testid="mobile-navbar-logout" onClick={() => { this.onClick('logout') }}>
            <i className='materialIcon'>exit_to_app</i>
            <label className="_marginLeft--xxsmall copy -secondary"><strong> Logout </strong></label>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    fc_lead: state.fc_lead,
    referralModal: state.shared.ui.modal.referralModal,
    user: state.user,
    businessAccount: state.businessAccount,
  };
};

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
  signOut: () => dispatch(signOut()),
  openModal: () => dispatch(openModal('referralModal'))
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileNav);



// WEBPACK FOOTER //
// ./src/features/account/containers/MobileNav.js